module.exports = __webpack_public_path__ + "img/logo.844cdf91.png";